import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./SettingsPage.css";
import {
  getCurrentServiceFee,
  ServiceFee,
} from "../../services/serviceFeeService";
import UpdateServiceFeeModal from "../../compoonents/UpdateServiceFeeModal/UpdateServiceFeeModal";
import feeIcon from "../../assets/images/purchaseicon.png";
import { FiUser, FiChevronRight } from "react-icons/fi";
import { useAccess } from "../../hooks/useAccess";
import Can from "../../compoonents/Can";
import AccountSecurityPanel from "./AccountSecurityPanel";
import { PaymentSettingsPanel, ReferralSettingsPanel } from "./PlatformSettingsPanels";

const SettingsPage: React.FC = () => {
  const { can, isSuperAdmin } = useAccess();
  const canReadFees = can("service_charges.read");
  const navigate = useNavigate();
  const [serviceFee, setServiceFee] = useState<ServiceFee | null>(null);
  const [loadingFee, setLoadingFee] = useState(true);
  const [feeLoadError, setFeeLoadError] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (!canReadFees) { setLoadingFee(false); return; }
    const fetchFee = async () => {
      setLoadingFee(true);
      setFeeLoadError(false);
      try {
        const feeData = await getCurrentServiceFee();
        setServiceFee(feeData);
      } catch (err) {
        setFeeLoadError(true);

      } finally {
        setLoadingFee(false);
      }
    };
    fetchFee();
  }, [canReadFees]);

  const handleUpdateSuccess = (updatedFee: ServiceFee) => {
    setServiceFee(updatedFee);
    setFeeLoadError(false);
    setIsModalOpen(false);
  };

  return (
    <div className="settings-page">
      <h1 className="page-main-title">Settings</h1>

      <div className="settings-layout">
      <AccountSecurityPanel />
      <Can permission="referrals.read"><ReferralSettingsPanel /></Can>
      {isSuperAdmin && <PaymentSettingsPanel />}
      <section className="settings-section">
        <h2 className="settings-section-title">Account</h2>
        <button
          type="button"
          className="settings-link-row"
          onClick={() => navigate("/profile-upload")}
        >
          <span className="settings-link-icon">
            <FiUser />
          </span>
          <span className="settings-link-text">
            <span className="settings-link-label">Profile picture</span>
            <span className="settings-link-hint">
              Upload or change your avatar
            </span>
          </span>
          <FiChevronRight className="settings-link-chevron" />
        </button>
      </section>

      <Can permission="service_charges.read"><section className="settings-section">
        <h2 className="settings-section-title">Platform</h2>
        <div className="settings-grid settings-grid-single">
          <div className="settings-card card-live-data card-primary">
            <div className="card-header">
              <h3 className="card-title">Service Fee</h3>
            </div>
            <div className="card-content">
              {loadingFee ? (
                <p className="loading-text">Loading...</p>
              ) : serviceFee ? (
                <p className="live-data-value">{serviceFee.percentage}%</p>
              ) : feeLoadError ? (
                <p className="error-text">
                  Unable to check the current service fee.
                </p>
              ) : (
                <p className="loading-text">No service fee set.</p>
              )}
              {!loadingFee && can("service_charges.manage") && (
                <button
                  type="button"
                  className="update-link"
                  onClick={() => setIsModalOpen(true)}
                >
                  {serviceFee ? "Update Fee" : "Set Service Fee"}
                </button>
              )}
            </div>
            <div className="card-icon-wrapper">
              <img src={feeIcon} alt="" className="card-icon" aria-hidden />
            </div>
          </div>
        </div>
      </section></Can>

      </div>

      {isModalOpen && (
        <UpdateServiceFeeModal
          currentPercentage={serviceFee?.percentage}
          onClose={() => setIsModalOpen(false)}
          onSuccess={handleUpdateSuccess}
        />
      )}
    </div>
  );
};

export default SettingsPage;
